import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
// import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
// import TimeAgo from "react-timeago";
// import Icon from '@material-ui/core/Icon';
// import { Link } from "routes";
// import styled from 'styled-components';
// import {getMobileNewsItemVideoThumbnail, extractYoutubeVideoID} from '/utils/common'
// import SponsorChip from '/components/sponsorChip';
// import ImgThumbnailSmall from '/components/imgThumbnailSmall';
// import classNames from 'classnames';
// import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
// import BrandTeaserLogo from '/components/brandTeaserLogo';
import VideoCardParts from '/components/Video/VideoCardParts';
import VideoCardPoster from "/components/Video/VideoCardPoster";
// import PlayIconButton from "/components/playIconButton";
import { compose } from 'recompose';
import withWidth from '@material-ui/core/withWidth';

const styles = theme => ({
  textContainer: {
    padding: '0px 0px 0px 14px'
  },
  img: {
    background: 'rgba(128, 128, 128, 0.11)',
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
    width: '100%',
    height: 100,
    objectFit: 'cover'
  },
  customDivider: {
    margin: '14px 0px 14px',
    backgroundColor: '#312e2e'
  },
  playerIconStyle: {
    color: '#ed7123',
    position: 'absolute',
    bottom: 2,
    left: 2,
    fontSize: 25
  },
  playerIconWrapperStyle: {
    width: 32,
    height: 32, 
    background: '#fff',
    position: 'absolute',
    borderRadius: '50%',
    bottom: 5,
    left: 4,
    border: '2px solid #ed7123'
  },

});

class VideoDetailUpNextItem extends React.Component {
  render(){
    const { classes, className, playlistPos, isDesktopPlaylist, playlistId, keyIndex, item, isSmallPoster } = this.props;
    const mobile_poster = !item.playlist_id ? item.posters.mobile_video_section_teaser : item.videos ? item.videos.posters.mobile_video_section_teaser : null;
    const desktop_poster = !item.playlist_id ? item.posters.next_video_teaser : item.videos ? item.videos.posters.next_video_teaser : null;
    const poster =  isSmallPoster ? mobile_poster : desktop_poster;
    const tvTypeIndex = item.categories && item.categories.findIndex((category) => category.type === 'TV')
    const routeName = tvTypeIndex >= 0 ? 'tvDetail' : 'videoDetail';

    return(            
        <React.Fragment>
            <Grid
                container
                direction="row" className="playlistHoverWrapper"
                className="video-teaser-gtm-track"
                style={{background: (playlistPos && playlistPos == keyIndex + 1) ? '#707070' : '', padding: playlistId ? isDesktopPlaylist ? '4px 4px 4px 0px' : 14 : '' }}
            >  
                <Grid xs={ isDesktopPlaylist ? 3: 4} item>  
                <div style={{display: 'flex', alignItems: 'center'}}>
                    {
                    isDesktopPlaylist ? 
                    <div style={{ padding: '0px 5px', color: 'rgba(255, 255, 255, 0.5)', fontSize: 12 }}>{isDesktopPlaylist ? keyIndex + 1 : null}</div>
                    : null
                    } 
                    <VideoCardPoster 
                    lazyload={isDesktopPlaylist ? false : true} 
                    playlistId={playlistId} 
                    routeName={routeName}
                    item={item} 
                    videoPoster={poster} 
                    videoImgHeight={ isDesktopPlaylist ? 64 : this.props.width === 'xs' ? 100 : 90 } />
                </div>
                </Grid>
                <Grid item xs={ isDesktopPlaylist && playlistId ? 9: 8} className={classes.textContainer} style={{padding: (playlistPos && playlistPos == keyIndex + 1) ? '0px 10px 0px 10px' : ''}}>
                    <VideoCardParts 
                    playlistId={playlistId} 
                    isDesktopPlaylist={isDesktopPlaylist} 
                    routeName={routeName}
                    item={item} 
                    className={className} />
                </Grid>
            
            </Grid>
            { playlistId ?
            isDesktopPlaylist ? null :
                <Divider style={{ backgroundColor: '#312e2e' }} />
            : <Divider className={classes.customDivider} />}
        </React.Fragment>
    )
    }
}

VideoDetailUpNextItem.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(
  withWidth(),
  withStyles(styles))(VideoDetailUpNextItem);
